import { connect } from 'react-redux';
import {
  getPaginatedPlans,
  exportAnnualPlansToCSV,
  exportAnnualPlansToExcel,
  setCurrentVersion,
  setFulfillmentVersion,
  setReadOnlyMode,
  setCreatingOutOfTimePlan,
  resetPlansState,
  setApYear,
  setCurrentBusinessUnit,
  deleteAnnualPlan,
  setCurrentPlanId,
  setSelectedHierarchicalModel,
  reopenPlanVersion,
  reopenFulfillmentVersion,
  anularPlanVersion,
  returnPlanToDefinition,
  fetchCurrentUserRoles,
  fetchOutOfTimeRequestStatus,
  submitOutOfTimeRequest,
  processOutOfTimeRequestDecision,
} from '@/core/slices/plans';
import { resetActivitiesState } from '@/core/slices/activities';
import { resetChecklistState } from '@/core/slices/checklists';
import { resetFocusState } from '@/core/slices/focuses';
import { resetObjectivesState } from '@/core/slices/objectives';
import { resetRequirementsState } from '@/core/slices/requirements';
import {
  plans,
  filterOptions,
  isLoadingPlans,
  errorMessagePlans,
  currentPage,
  totalPages,
  pageSize,
  periods,
  userRoles,
  loadingUserRoles,
  outOfTimeRequestStatus,
  loadingOutOfTimeRequestStatus,
  submittingOutOfTimeRequest,
  processingOutOfTimeDecision,
  processingReopenDecision,
} from '@/core/selectors';
import { RootState } from '@/core/types/state';

import AnnualPlanning from '../../../components/AnnualPlanning/AnnualPlanning';

const ConnectedAnnualPlanning = connect(
  (state: RootState) => ({
    plans: plans(state),
    filterOptions: filterOptions(state),
    isLoadingPlans: isLoadingPlans(state),
    errorMessagePlans: errorMessagePlans(state),
    currentPage: currentPage(state),
    totalPages: totalPages(state),
    pageSize: pageSize(state),
    periods: periods(state),
    userRoles: userRoles(state),
    loadingUserRoles: loadingUserRoles(state),
    outOfTimeRequestStatus: outOfTimeRequestStatus(state),
    loadingOutOfTimeRequestStatus: loadingOutOfTimeRequestStatus(state),
    submittingOutOfTimeRequest: submittingOutOfTimeRequest(state),
    processingOutOfTimeDecision: processingOutOfTimeDecision(state),
    processingReopenDecision: processingReopenDecision(state),
  }),
  {
    getPaginatedPlans,
    exportAnnualPlansToCSV,
    exportAnnualPlansToExcel,
    setCurrentVersion,
    setFulfillmentVersion,
    resetActivitiesState,
    resetChecklistState,
    resetFocusState,
    resetObjectivesState,
    resetRequirementsState,
    resetPlansState,
    setReadOnlyMode,
    setCreatingOutOfTimePlan,
    setApYear,
    deleteAnnualPlan,
    setCurrentPlanId,
    setSelectedHierarchicalModel,
    reopenPlanVersion,
    reopenFulfillmentVersion,
    anularPlanVersion,
    returnPlanToDefinition,
    fetchCurrentUserRoles,
    fetchOutOfTimeRequestStatus,
    submitOutOfTimeRequest,
    processOutOfTimeRequestDecision,
    setCurrentBusinessUnit,
  },
)(AnnualPlanning);

export default ConnectedAnnualPlanning;
